import { configureStore } from "@reduxjs/toolkit";
import uiReducer from "../features/ui/uiSlice";
import modalReducer from "../features/modal/modalSlice";

// agrega aquí otros reducers de tu app
export const store = configureStore({
  reducer: {
    ui: uiReducer,
    modal: modalReducer,
  },
  // middleware: (getDefault) => getDefault().concat(customMiddlewareIfNeeded),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
